export class Result<T> {
  success: boolean = false;
  data: T|null = null;
  error: Error|null = null;
  constructor(success: boolean, data:T|null, error:Error|null) {
    this.success = success;
    this.data = data;
    this.error = error;
  }
}